
import { createTheme } from "@mui/material/styles";
import { tableScrollbarStyles } from "../../../components/layouts/tableScrollbarStyles";
import { searchFieldOutlinedInputStyles } from "../../../components/ui/searchFieldStyles";

const theme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#1e3a8a",
    },

    secondary: {
      main: "#3b82f6",
    },

    // PURE WHITE UI
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },

    // DARK TEXT
    text: {
      primary: "#111827",
      secondary: "#475569",
      disabled: "#64748B",
    },

    divider: "#e5e7eb",
  },

  typography: {
    fontFamily:
      "Inter, Roboto, system-ui, sans-serif",

    h4: {
      fontWeight: 700,
      letterSpacing: "-0.5px",
    },

    h5: {
      fontWeight: 600,
    },

    h6: {
      fontWeight: 600,
    },

    body1: {
      fontSize: "0.95rem",
    },

    body2: {
      fontSize: "0.85rem",
      color: "#475569",
    },

    button: {
      textTransform: "none",
      fontWeight: 600,
      fontSize: "0.9rem",
    },
  },

  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: ({ theme }) => tableScrollbarStyles(theme),
      },
    },
  },

  shape: {
    borderRadius: 12,
  },

  components: {
    // BUTTON
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 10,
          padding: "8px 16px",
          '&&[data-app-cancel="true"]': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
              borderColor: theme.palette.primary.dark,
            },
          },
        }),

        containedPrimary: {
          boxShadow:
            "0 6px 18px rgba(30,58,138,0.3)",

          "&:hover": {
            boxShadow:
              "0 10px 25px rgba(30,58,138,0.4)",
          },
        },
      },
    },

    // CARD
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow:
            "0 12px 30px rgba(0,0,0,0.08)",
          backgroundColor: "#ffffff",
        },
      },
    },

    // TEXT FIELD
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },

    // TABLE HEADER
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
        },
      },
    },

    // TABLE CELL
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          color: "#111827",
          backgroundColor: "#ffffff",
        },

        body: {
          color: "#111827",
        },
      },
    },

    // DIVIDER
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#e5e7eb",
        },
      },
    },

    // MENU
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          boxShadow:
            "0 15px 40px rgba(0,0,0,0.15)",
          backgroundColor: "#ffffff",
          color: "#111827",
        },
      },
    },

    // PAPER
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
        },
      },
    },

    // INPUT LABEL
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#475569",

          "&.Mui-focused": {
            color: "#1e3a8a",
          },
        },
      },
    },

    // OUTLINED INPUT
    MuiOutlinedInput: {
      styleOverrides: {
        root: (props) => ({
          ...searchFieldOutlinedInputStyles(props.theme),
          color: "#111827",
          backgroundColor: "#ffffff",

          "& fieldset": {
            borderColor: "#e5e7eb",
          },

          "&:hover fieldset": {
            borderColor: "#94a3b8",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#1e3a8a",
          },
        }),
      },
    },

    // SELECT
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "#475569",
        },
      },
    },

    // MENU ITEM
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: "#111827",
          backgroundColor: "#ffffff",

          "&:hover": {
            backgroundColor: "#f8fafc",
          },

          "&.Mui-selected": {
            backgroundColor:
              "rgba(30,58,138,0.08)",
          },

          "&.Mui-selected:hover": {
            backgroundColor:
              "rgba(30,58,138,0.12)",
          },
        },
      },
    },
  },
});

export default theme;
